// CardSection.jsx
import React, { useState } from "react";
import { Paper, Box, IconButton } from "@mui/material";
import { ExpandMore, ExpandLess } from "@mui/icons-material";
import MyTitle from "./MyTitle";
import MySelect from "./MySelect";
import MyInputNum from "./MyInputNum";
import MyTable from "./MyTable";

const CardSection = ({
  title,
  myStore,
  listItem = [],
  handleSelectedItemChange,
  selectedItem,
  handleChangeValue,
  handleAdd,
  selectedValue,
  onClick,
  onRemoveRow,
  children,
  showDefaultControls = true,
  open: controlledOpen,
  setOpen: setControlledOpen,
}) => {
  const [showComponents, setShowComponents] = useState(false);
  const isControlled =
    controlledOpen !== undefined && setControlledOpen !== undefined;
  const open = isControlled ? controlledOpen : showComponents;

  const handleCardClick = () => {
    if (isControlled) {
      setControlledOpen(!controlledOpen);
    } else {
      setShowComponents((prev) => !prev);
    }
  };

  return (
    <Paper
      elevation={0}
      variant="outlined"
      role="button"
      tabIndex={0}
      aria-expanded={open}
      aria-label={`Toggle ${title} section`}
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "stretch",
        gap: 0.5,
        mt: 2,
        p: 1,
      }}
    >
      <Box
        onClick={handleCardClick}
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          cursor: "pointer",
          "&:hover": {
            backgroundColor: "action.hover",
          },
          borderRadius: 1,
          p: 0.5,
        }}
      >
        <MyTitle text={title} />
        <IconButton
          size="small"
          onClick={(e) => {
            e.stopPropagation();
            handleCardClick();
          }}
          sx={{ ml: 1 }}
        >
          {showComponents ? <ExpandLess /> : <ExpandMore />}
        </IconButton>
      </Box>

      {open && (
        <Box
          onClick={(e) => e.stopPropagation()} // empêche de refermer en cliquant à l’intérieur
          sx={{
            display: "flex",
            flexDirection: "column",
            gap: 0.25,
            mt: 0.5,
            width: "auto",
            maxWidth: "100%",
            px: 1.5, // horizontal padding
            pb: 1, // bottom padding
          }}
        >
          {/* 👉 children affiché en premier (MyMatrixForm ici) */}
          {children}

          {/* 👉 contrôles classiques optionnels */}
          {showDefaultControls && (
            <>
              <MySelect
                listItem={listItem}
                value={selectedItem}
                onChange={handleSelectedItemChange}
              />
              <MyInputNum
                disabled={!selectedItem}
                selectedValue={selectedValue}
                handleChangeValue={handleChangeValue}
                handleAdd={handleAdd}
              />
              <MyTable myStore={myStore} onClick={onClick} onRemoveRow={onRemoveRow} />
            </>
          )}
        </Box>
      )}
    </Paper>
  );
};

export default CardSection;
